export default __webpack_public_path__ + "static/media/avatar_trex8.e964f50e.mp3";